import React, { useState, useEffect } from 'react';
import { Route, Routes, unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Header } from './components/Header.jsx';
import './App.css';

import NotFound from './pages/NotFound';
import HeaderMobile from './components/Header-mobile.jsx';
import Footer from './components/Footer';

import Home from './pages/Home.jsx';

import Categories from './pages/Categories';
import DesignProjectSeparator from './pages/DesignProjectSeparator.jsx';
import DesignOffice from './pages/Design-office';
import DesignAndProjects from './pages/Design-office-and-projects';
import ProjectDetail from './pages/Project-detail.jsx';
import FurniturePage from './pages/Mobilier-habitat.jsx';
import FurnitureProPage from './pages/Mobilier-pro.jsx';
import FurnitureExterieur from './pages/Mobilier-exterieur';
import ArticlePage from './pages/Mobilier-detail';
import ActualitesPage from './pages/Actualites';
import ActualiteDetail from './pages/ActualiteDetail';
import ContactUs from './pages/ContactUs';
import AccessoiresBody from './pages/Accessoires';

import MobilierHabitatDetail from './pages/Mobilier-habitat-detail';
import MobilierProDetail from './pages/Mobilier-pro-detail';
import MobilierExterieurDetail from './pages/Mobilier-exterieur-detail';
import AccessoiresDetail from './pages/Accessoires-detail';
import OurBrands from './pages/Our-Brands';
import OurHistoryPage from './pages/Our-History';

const history = createBrowserHistory({ v7_startTransition: true });

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <div className="App bg-cream scroll-smooth select-none">
      <HistoryRouter history={history}>
        <div className="block lg:hidden">
          <HeaderMobile />
        </div>
        <div className="hidden lg:block">
          {/* if loading no Header */}
          {loading ? null : <Header />}
        </div>
        <Routes>
          <Route path="/">
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<DesignProjectSeparator />} />
            <Route path="/design-and-projects/" element={<DesignAndProjects />} />
            <Route path="/design-and-projects/:id/*" element={< ProjectDetail />} />
            <Route path="/design-office" element={<DesignOffice />} />
            <Route path="/our-brands" element={<OurBrands />} />
            <Route path="/our-history" element={<OurHistoryPage />} />
          </Route>
          <Route path="/categories">
            <Route path="" element={<Categories />} />
            <Route path="mobilier/habitat" element={<FurniturePage />} />
            <Route path="mobilier/habitat/:id/*" element={<MobilierHabitatDetail />} />
            <Route path="mobilier/professionnel" element={<FurnitureProPage />} />
            <Route path="mobilier/professionnel/:id/*" element={<MobilierProDetail />} />
            <Route path="mobilier/exterieur" element={<FurnitureExterieur />} />
            <Route path="mobilier/exterieur/:id/*" element={<MobilierExterieurDetail />} />
            <Route path="mobilier/blog/:id/*" element={<ArticlePage />} />
            <Route path="objets-accessoires" element={<AccessoiresBody />} />
            <Route path="objets-accessoires/:id/*" element={<AccessoiresDetail />} />
          </Route>
          <Route path="/actualites" element={<ActualitesPage />} />
          <Route path="/actualites/:id" element={<ActualiteDetail />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* if loading no footer */}
        {loading ? null : <Footer />}
      </HistoryRouter>
    </div>
  );
}

export default App;
